import React, { Component } from 'react';
import { ModalHeader, ModalTitle } from 'react-bootstrap';

class DetailsModalHeader extends Component {
  
    render() {
        return (
            <ModalHeader closeButton>
                <ModalTitle>{this.props.title}</ModalTitle>
            </ModalHeader>
        );
    }
}



export default DetailsModalHeader;